// @flow
import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import {
  TripAdvisorAwards,
  type AwardProps,
} from 'Components/widgets/tripadvisor-awards/TripAdvisorAwards.jsx';
import {
  TripAdvisorRatings,
  type TripAdvisorRatingsProps,
} from 'Components/widgets/tripadvisor-ratings/TripAdvisorRatings.jsx';
import {
  TripAdvisorReviews,
  type ReviewProps,
} from 'Components/widgets/tripadvisor-reviews/TripAdvisorReviews.jsx';

export type TripAdvisorLargeProps = {
  className?: string,
  awards?: Array<AwardProps>,
  ratings?: TripAdvisorRatingsProps,
  reviews?: Array<ReviewProps>,
};

export function TripAdvisorLarge(props: TripAdvisorLargeProps) {
  const { awards = [], className, ratings = {}, reviews } = props;

  if (isEmpty(awards) && isEmpty(ratings.subratings) && isEmpty(reviews)) return null;

  const classes =
    'flex items-center justify-center mx-2 p-4 w-1/3 rounded-tiny border-1 border-gray-light';

  return (
    <section className={classnames(className, 'flex justify-center -mx-2 pb-3')}>
      {!isEmpty(ratings.subratings) && (
        <div className={classes} style={{ width: '23.75rem' }}>
          <TripAdvisorRatings
            className="max-w-full w-full"
            {...ratings}
            subratings={ratings.subratings}
          />
        </div>
      )}
      {!isEmpty(reviews) && (
        <div className={classnames(classes, 'flex-1')}>
          <TripAdvisorReviews
            className="max-w-full w-full"
            maxLengthOfReview={150}
            // $FlowFixMe
            reviews={reviews}
          />
        </div>
      )}
      {!isEmpty(awards) && (
        <div className={classes} style={{ width: '17.5rem' }}>
          <TripAdvisorAwards className="max-w-full w-full" awards={awards} />
        </div>
      )}
    </section>
  );
}
